var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("delegationOrder.orderList.title")))]),
      _c("delegation-menu"),
      _c(
        "v-row",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("global.search"),
                  "append-icon": "search",
                  "hide-details": "",
                  "single-line": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "div",
            [
              _vm.hasPermissionForNewDelegationOrder
                ? _c(
                    "v-btn",
                    { attrs: { block: "", color: "accent", to: "/new-trip" } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("delegationOrder.orderList.newBusinessTrip")
                        )
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.delegationOrders,
          search: _vm.search,
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { staticClass: "text-left" },
                    [
                      _c("document-number", {
                        attrs: {
                          number: props.item.number,
                          "temp-number": props.item.custom_number
                        }
                      })
                    ],
                    1
                  ),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          !!props.item.delegated_user
                            ? props.item.delegated_user
                            : _vm.$t("global.notSet")
                        ) +
                        " "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          !!props.item.date_start
                            ? props.item.date_start
                            : _vm.$t("global.notSet")
                        ) +
                        " "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          !!props.item.date_end
                            ? props.item.date_end
                            : _vm.$t("global.notSet")
                        ) +
                        " "
                    )
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-center" },
                    [
                      _c("delegation-order-status-chip", {
                        attrs: { status: props.item.status }
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "text-center" },
                    [
                      _c("action-list", {
                        attrs: {
                          "action-list": props.item.actions,
                          "context-item-id": props.item.id
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }